import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { WithThor } from '@aviv-dxp/react-thor';
import Layout from './common/layout';
import { GlobalLoader } from './common/components';
import './utils/monitoring';
import { isProductionEnv } from './utils/ga4tracking/utils';
import { useConsent } from './utils/ga4tracking/useConsent';
export const App = () => {
    const isDevMode = !isProductionEnv();
    const consent = useConsent();
    return (_jsx(WithThor, { userConsent: consent, devMode: isDevMode, compatibilities: { GA3: false, GA4: true }, children: _jsx(Box, { children: _jsx(Layout, { fallback: _jsx(GlobalLoader, {}) }) }) }));
};
